import React, { useEffect, useState } from 'react'
import DataSource from '../DataSource'
import PendingConnectionBroadband from './PendingConnectionBroadband'
import PendingConnectionNewSim from './PendingConnectionNewSim'
import PendingConnectionMobile from "./PendingConnection/PendingConnectionMobile";
import pendingConnectionMockResponse from "../mockData/pendingConnection.json";
import PendingConnectionBroadbandV2 from "./PendingConnectionBroadbandV2";

const PendingConnections = () => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [connections, setConnections] = useState([])

    useEffect(() => {
	    getData().then()
    }, [])

    const getData = async () => {
        await DataSource.getData(`${process.env.MIX_LEGACY_API_URL}api/getPendingConnectionsV2`, result => {
            setIsLoaded(true)
            setConnections(result.data)
        })

        // if (pendingConnectionMockResponse) {
        //     setIsLoaded(true)
        //     setConnections(pendingConnectionMockResponse.data)
        // }
    }

    const Connections = connections.map((data, key) => {
        if (data.serviceDetails.type === 'mobile' || data.serviceDetails.type === 'sim') {
            return (
                <PendingConnectionMobile
                    key={key}
                    serviceDetails={data.serviceDetails ? data.serviceDetails : {}}
                    status={data.status ? data.status : []}
                />
            )
        }  else {
            return (
                <PendingConnectionBroadbandV2
                    key={key}
                    serviceDetails={data.serviceDetails ? data.serviceDetails : {}}
                    status={data.status ? data.status : []}
                />
            )
        }
    })

    return isLoaded ? Connections : ''
}

export default PendingConnections



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnections.js